module.exports = __webpack_public_path__ + "img/costal-6-3.629d1073.jpg";